//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "CrichtonRoyalBehavioralRatingScale",
  data() {
    return {
      form: {
        memory: "",
        directiveForce: "",
        talk: "",
        cooperate: "",
        intranqui: "",
      },
      hasScore: false,
      disabled: false,
      dataList: [
        { value: "0", name: "完好" },
        { value: "1", name: "偶有遗忘" },
        { value: "2", name: "短程记忆丧失" },
        { value: "3", name: "记忆短暂或不能记忆" },
      ],
      dataList1: [
        { value: "0", name: "完好" },
        { value: "1", name: "在住所或单位内能定向" },
        { value: "2", name: "认错人" },
        { value: "3", name: "保存了一些表达能力" },
        { value: "4", name: "不能接触" },
      ],
      dataList2: [
        { value: "0", name: "总是清晰的" },
        { value: "1", name: "能进行简单的交谈" },
        { value: "2", name: "能理解简单的问题，但不能提出需要" },
        { value: "3", name: "找不到路" },
        { value: "4", name: "完全丧失" },
      ],
      dataList3: [
        { value: "0", name: "主动配合" },
        { value: "1", name: "被动配合" },
        { value: "2", name: "需要说服" },
        { value: "3", name: "拒绝帮助" },
        { value: "4", name: "抗拒或退缩" },
      ],
      dataList4: [
        { value: "0", name: "没有" },
        { value: "1", name: "被动配合" },
      ],
      
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      let result = 0;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
        result += Number(form[key]);
      }
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        self.hasScore = true;
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/CrichtonRoyalBehavioralRatingScale.vue